import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { setMsgAsync, Message } from './notificationsSlice';

// Fetch the logged-in user's offices
export const getMyOfficesAsync = createAsyncThunk(
  'offices/getMyOffices',
  async (value, { dispatch }) => {
    try {
      const response = await axios.get('/api/offices/my-offices');
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  }
);

// Fetch active sessions for a specific office
export const getOfficeActiveSessionsAsync = createAsyncThunk(
  'offices/getOfficeActiveSessions',
  async (officeId, { dispatch }) => {
    try {
      const response = await axios.get(`/api/orders/active/${officeId}`);
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  }
);

const initialState = {
  loading: {
    myOffices: false,
    officeSessions: false,
  },
  myOffices: [],
  officeSessions: [],
  currentSessionId: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentSessionId: (state, action) => {
      state.currentSessionId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle fetching my offices
      .addCase(getMyOfficesAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.myOffices = false;
          return;
        }
        state.myOffices = action.payload;
        state.loading.myOffices = false;
      })
      .addCase(getMyOfficesAsync.pending, (state) => {
        state.loading.myOffices = true;
      })
      .addCase(getMyOfficesAsync.rejected, (state) => {
        state.loading.myOffices = false;
      })
      // Handle fetching office active sessions
      .addCase(getOfficeActiveSessionsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.officeSessions = false;
          return;
        }
        state.officeSessions = action.payload;
        state.loading.officeSessions = false;
      })
      .addCase(getOfficeActiveSessionsAsync.pending, (state) => {
        state.loading.officeSessions = true;
      })
      .addCase(getOfficeActiveSessionsAsync.rejected, (state) => {
        state.loading.officeSessions = false;
      });
  }
});

export const getMyOffices = (state) => state.app.myOffices;
export const getOfficeSessions = (state) => state.app.officeSessions;
export const getLoadingMyOffices = (state) => state.app.loading.myOffices;
export const getLoadingOfficeSessions = (state) => state.app.loading.officeSessions;
export const getCurrentSessionId = (state) => state.app.currentSessionId;

export const { setCurrentSessionId } = appSlice.actions;

export default appSlice.reducer;
